import { all, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';
import { t } from 'copy/t';
import {
  PASSWORD_RESET_REQUEST_REQUEST,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_REQUEST_FAILURE,
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAILURE,
} from './constants';
import {
  passwordResetRequestFailure,
  passwordResetRequestSuccess,
  passwordResetFailure,
  passwordResetSuccess,
} from './actions';
import { apiSaga } from 'sagas';
import { postPasswordReset, patchPasswordReset } from 'utils/api';

export function* passwordResetRequestFlow({ payload }) {
  yield* apiSaga(
    postPasswordReset,
    [{ email: payload.email }],
    passwordResetRequestSuccess,
    passwordResetRequestFailure
  );
}

export function* passwordResetRequestSuccessFlow() {
  toast.success(t('toast.forgotPassword.resetEmailSent'));
}

export function* passwordResetRequestFailureFlow() {
  toast.error(t('toast.forgotPassword.resetEmailFailed'));
}

export function* passwordResetFlow({ payload }) {
  const args = [{
    password: payload.password,
    password_confirmation: payload.password_confirmation,
    reset_password_token: payload.reset_password_token,
  }];

  yield* apiSaga(patchPasswordReset, args, passwordResetSuccess, passwordResetFailure);
}

export function* passwordResetSuccessFlow() {
  toast.success(t('toast.forgotPassword.passwordUpdated'));
}

export function* passwordResetFailureFlow({ payload }) {
  const message =
    payload?.error ||
    payload?.errors?.[0]?.detail ||
    t('toast.forgotPassword.resetFailed');
  toast.error(message);
}

export default function* watchSignIn() {
  yield all([
    takeLatest(PASSWORD_RESET_REQUEST_REQUEST, passwordResetRequestFlow),
    takeLatest(PASSWORD_RESET_REQUEST_SUCCESS, passwordResetRequestSuccessFlow),
    takeLatest(PASSWORD_RESET_REQUEST_FAILURE, passwordResetRequestFailureFlow),
    takeLatest(PASSWORD_RESET_REQUEST, passwordResetFlow),
    takeLatest(PASSWORD_RESET_SUCCESS, passwordResetSuccessFlow),
    takeLatest(PASSWORD_RESET_FAILURE, passwordResetFailureFlow),
  ]);
}
